module.exports = __webpack_public_path__ + "41a32059e9a8eb6f1ceb7ba7ff4fdde1.svg";